import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./plugins/element";

import "../src/assets/scss/public.scss";
import "../src/assets/scss/components.scss";
import "../src/assets/scss/style.scss";
import i18n from './lang/index'
import './permission.js'

Vue.prototype.$Bus = new Vue();
Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
